import { useTranslation } from "react-i18next";

interface NoDependableQuestionsMessageProps {
  supportedTypes: string[];
}

export default function NoDependableQuestionsMessage({
  supportedTypes,
}: NoDependableQuestionsMessageProps) {
  const { t } = useTranslation();
  return (
    <>
      {t("dependentQuestions.noDependableQuestions")}
      <ul className="list-disc pl-5 mt-3">
        {supportedTypes.map((type) => (
          <li key={type}>{t(`questionTypes.${type}`)}</li>
        ))}
      </ul>
    </>
  );
}
